import { DetailBpLineinfos } from './../../bp-components.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import * as moment from 'moment';

export interface DialogData {
  referentiel: Observable<DetailBpLineinfos>;
  bpLineForm: UntypedFormGroup;
  titre: string;
}
@Component({
  selector: 'app-modal-create-bp-line',
  templateUrl: './modal-create-bp-line.component.html',
  styleUrls: ['./modal-create-bp-line.component.scss']
})
export class ModalCreateBpLineComponent implements OnInit, AfterViewChecked {

  referentiel: DetailBpLineinfos = new DetailBpLineinfos();
  minDateLiv: string = moment(new Date()).format('YYYY-MM-DD');
  bpLineForm: UntypedFormGroup;

  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              private readonly changeDetectorRef: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.bpLineForm = this.data.bpLineForm;
    this.data.referentiel.subscribe((ref: DetailBpLineinfos) => {
      this.referentiel = ref;
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    if (this.bpLineForm.valid) {
      this.dialogRef.close(this.bpLineForm);
    }
    this.displayErrors();
  }

  displayErrors(): void {
    for (const bpline in this.bpLineForm.controls) {
      if (bpline) {
        this.bpLineForm.controls[bpline].markAsTouched();
      }
    }
  }
}
